import React from 'react';
import * as S from './ErrorMessage.styled';

interface ErrorMessageProps {
  title?: string;
  message?: string;
}

export default function ErrorMessage({
  title = 'Ocorreu um erro inesperado!',
  message = 'Não foi possível trazer os dados da tabela. Feche a modal e tente novamente.'
}: ErrorMessageProps) {
  return (
    <S.Container>
      <S.Icon data-testid="error-icon" />
      <S.Title>{title}</S.Title>
      <S.Message>{message}</S.Message>
    </S.Container>
  );
}
